import React from 'react'
import PropTypes from 'prop-types'
import groupBy from 'lodash/groupBy'

import useBooks from '../hooks/useBooks'
import Icon from '../components/Icon'
import Box from '../styled/Box'

function Books(props = {}) {
  const { books, status } = useBooks()

  if (status === 'LOADING') {
    return (
      <Box as="p" color="medium" fontSize="s" pt="xl" textAlign="center">
        Getting the latest books data&hellip;
      </Box>
    )
  }

  const booksByYear = groupBy(books, 'year')
  const years = Object.keys(booksByYear).reverse()

  return (
    <>
      {years.map((year, idx) => (
        <Box key={idx} mb="xl">
          <Box mb="l">
            <Box as="h2" mb="0">
              {year}
            </Box>
            <Box
              as="p"
              color="medium"
              fontFamily="heading"
              fontSize="s"
              textTransform="uppercase"
            >
              Total Books Read: {booksByYear[year].length}
            </Box>
          </Box>
          <Box
            display={{ md: 'grid' }}
            gridTemplateColumns={{
              md: 'repeat(4, 1fr)',
              lg: 'repeat(5, 1fr)',
              xl: 'repeat(6, 1fr)',
            }}
          >
            {booksByYear[year].map(book => (
              <Book key={book.id} {...book} />
            ))}
          </Box>
        </Box>
      ))}
    </>
  )
}

function Book(props = {}) {
  return (
    <Box
      border="1px solid"
      borderColor="border"
      mb="-1px"
      mr="-1px"
      p="base"
      textAlign="center"
    >
      {props.image ? (
        <Box as="a" href={props.url} display="block" mb="base">
          <Box as="img" src={props.image} height="200px" mx="auto" />
        </Box>
      ) : (
        <Box
          bg="border"
          borderRadius="base"
          height="200px"
          width="150px"
          mb="base"
          mx="auto"
        />
      )}
      <Box
        as="h3"
        fontFamily="base"
        fontSize="s"
        fontWeight="bold"
        textTransform="none"
      >
        {props.favorite === 'TRUE' ? (
          <Icon color="primary" mr="xs" position="relative" size="18" top="3px">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
          </Icon>
        ) : null}
        <Box as="a" href={props.url}>
          {props.title}
        </Box>
      </Box>
      <Box as="p" fontSize="xs">
        {props.author}
      </Box>
    </Box>
  )
}

Books.propTypes = {
  data: PropTypes.shape({
    author: PropTypes.string,
    favorite: PropTypes.string,
    id: PropTypes.string,
    image: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    year: PropTypes.string,
  }),
}

export default Books
